module.exports = __webpack_public_path__ + "img/award_badge_long_2024.1d2b876a.png";